import React, {Component} from 'react'
import FJToolbarIconButton from './FJToolbarIconButton'
import classNames from 'classnames'
import FJDropDown from "fj-components/FJDropDown"

import InlineSVG from "react-inlinesvg";
import FJGridsIcon from '../../../icon/FJGridsIcon.svg'
import FJTextBottom from "../../../icon/FJTextBottom.svg";
import FJTextCenter from "../../../icon/FJTextCenter.svg";
import FJTextLeft from "../../../icon/FJTextLeft.svg";
import FJTextLeftBottom from "../../../icon/FJTextLeftBottom.svg";
import FJTextLeftTop from "../../../icon/FJTextLeftTop.svg";
import FJTextRight from "../../../icon/FJTextRight.svg";
import FJTextRightBottom from "../../../icon/FJTextRightBottom.svg";
import FJTextRightTop from "../../../icon/FJTextRightTop.svg";
import FJTextTop from "../../../icon/FJTextTop.svg";

import './FJPosition.less'
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJUtil from "../../../util/FJUtil";

const positionTypes = [
  FJCoreConstant.LEFT_TOP,
  FJCoreConstant.TOP,
  FJCoreConstant.RIGHT_TOP,
  FJCoreConstant.LEFT,
  FJCoreConstant.CENTER,
  FJCoreConstant.RIGHT,
  FJCoreConstant.LEFT_BOTTOM,
  FJCoreConstant.BOTTOM,
  FJCoreConstant.RIGHT_BOTTOM,
];

class FJPosition extends Component {

  _listComponent = () => {
    let comps = [];
    let supportPositions = this.props.supportPositions || positionTypes;
    let positionType = this.props.positionType;
    for (let i = 0; i < 9; i++) {
      let disabled = supportPositions.indexOf(positionTypes[i]) === -1;
      let cn = classNames('c-position-grid_item', {
        active: positionType === positionTypes[i],
        allowed: !disabled,
        disabled: disabled
      });
      comps.push((
        <div key={i} className={cn} ref={(ele) => {
          this['tpos' + i] = ele
        }}
             onClick={() => {
               disabled || this._dataChange(i)
             }}
        >
          {this._getIcon(i)}
        </div>
      ));
    }
    return comps;
  };
  _getIcon = (index) => {
    switch (index) {
      case 0:
        return <InlineSVG src={FJTextLeftTop} element='div'/>;
      case 1:
        return <InlineSVG src={FJTextTop} element='div'/>;
      case 2:
        return <InlineSVG src={FJTextRightTop} element='div'/>;
      case 3:
        return <InlineSVG src={FJTextLeft} element='div'/>;
      case 4:
        return <InlineSVG src={FJTextCenter} element='div'/>;
      case 5:
        return <InlineSVG src={FJTextRight} element='div'/>;
      case 6:
        return <InlineSVG src={FJTextLeftBottom} element='div'/>;
      case 7:
        return <InlineSVG src={FJTextBottom} element='div'/>;
      case 8:
        return <InlineSVG src={FJTextRightBottom} element='div'/>;
    }
  };
  _dataChange = (idx) => {
    if (idx !== this.props.positionType && this.props.positionChange) {
      this.props.positionChange(positionTypes[idx]);
    }
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {

    let {disabled, className} = this.props;
    let cn = classNames('u-tooltip-bottom c-toolbar-icon-btn', className);

    return (
      <FJDropDown overlay={
        <div className="c-position-popup-panel">
          <div className="c-position-popup-panel-box">{this._listComponent()}</div>
        </div>
      }
                  canTriggerActive
                  disabled={disabled}
                  triggerClick={() => {FJCoreUtil.triggerBodyMousedown()}}
                  toggleTooltip={this._toggleTooltip}
                  hasArrow={true}
      >
        <FJToolbarIconButton disabled={disabled}
                             className={cn}
                             tooltip={FJLocalStore._('position')}
                             icon={<InlineSVG src={FJGridsIcon} element='div'/>}/>
      </FJDropDown>
    );
  }
}

export default FJPosition;
